import Ajax from "Utils/ajax";
export const getStaffList = (data) => Ajax.post('hr/getAllStaff',data);
export const insertTimeRecord = (data) => Ajax.post('hr/insertTimeRecord',data);